import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'iw-tinymce',
  templateUrl: './tinymce.component.html',
  styleUrls: ['./tinymce.component.scss']
})



export class TinymceComponent implements OnInit {
  @Input() texto = '';
  @Input() lines = 5;
  height = 200;
  @Input() showMenubar = false;
  @Input() showToolbar = false;
  @Input() readOnly = false;
  init = '';
  plugins = [
    'advlist autolink lists link charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount'
  ];
  toolbar = 'undo redo | formatselect | bold italic backcolor | \
   alignleft aligncenter alignright alignjustify | \
   bullist numlist outdent indent | removeformat | help';
  constructor() { }

  ngOnInit() {
    if (this.lines > 5) {
      this.height = this.lines * 40;
    }
    this.init = `{
      height: ${this.height},
      menubar: ${this.showMenubar},
      toolbar: ${this.showToolbar},
      readonly: ${this.readOnly},
       plugins: ${this.plugins},
     toolbar:${this.toolbar}
   }`;

  }
}



// WEBPACK FOOTER //
// ./src/app/examples/tinymce/tinymce.component.ts